import styled from 'styled-components';

export const BreadcrumbText = styled.span`
    font-size: 1.4rem;
    font-weight: 500;
    cursor: pointer;
`;

export const BreadcrumbSeparator = styled.span`
    font-size: 1.4rem;
    font-weight: 500;
`;

export const FolderIconWrapper = styled.div`
    width: 4.8rem;
    max-width: 4.8rem;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const CellNameText = styled.div`
    min-width: 0;
`;

export const EmptyStateContainer = styled.div`
    height: 50.5rem;
`;
